import type { FeatureFlagSnapshot } from '../types';

/**
 * Feature flags — read from Vite (VITE_*) or Node/edge (bare) env vars.
 * Visible transparency can launch before C2PA signing.
 */
function readBool(value: string | undefined, defaultValue: boolean): boolean {
  if (value === undefined || value === '') return defaultValue;
  const v = value.trim().toLowerCase();
  if (v === '1' || v === 'true' || v === 'yes' || v === 'on') return true;
  if (v === '0' || v === 'false' || v === 'no' || v === 'off') return false;
  return defaultValue;
}

function env(name: string): string | undefined {
  try {
    // Vite client
    const meta = (import.meta as ImportMeta & { env?: Record<string, string> }).env;
    if (meta?.[name] !== undefined) return meta[name];
    if (meta?.[`VITE_${name}`] !== undefined) return meta[`VITE_${name}`];
  } catch {
    // ignore
  }
  if (typeof process !== 'undefined' && process.env) {
    return process.env[name] ?? process.env[`VITE_${name}`];
  }
  return undefined;
}

export function getAITransparencyFlags(
  overrides?: Partial<FeatureFlagSnapshot>,
): FeatureFlagSnapshot {
  return {
    aiTransparencyEnabled: overrides?.aiTransparencyEnabled ?? readBool(env('AI_TRANSPARENCY_ENABLED'), true),
    aiProvenanceEnabled: overrides?.aiProvenanceEnabled ?? readBool(env('AI_PROVENANCE_ENABLED'), true),
    c2paSigningEnabled: overrides?.c2paSigningEnabled ?? readBool(env('C2PA_SIGNING_ENABLED'), false),
  };
}

export const ENV_FLAG_NAMES = [
  'AI_TRANSPARENCY_ENABLED',
  'AI_PROVENANCE_ENABLED',
  'C2PA_SIGNING_ENABLED',
  'VITE_AI_TRANSPARENCY_ENABLED',
  'VITE_AI_PROVENANCE_ENABLED',
  'VITE_C2PA_SIGNING_ENABLED',
] as const;
